import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import AccountTreeDto from '../../../models/account/AccountTreeDto';

export const ChangeAccountResolver: ResolveFn<AccountTreeDto> = (route, state) => {
  return inject(UserService).getAccountTrees()
};
